<!-- <div class="container">
    <h1>Angular Theme Switcher</h1>
    <button (click)="toggleTheme()">Toggle Theme</button>

    <p>This text will adapt to the selected theme.</p>
</div> -->
<div class="app-layout">
  @if (showStepper) {
    <aside class="sidebar">
      <fidi-stepper-sidebar
        [activeStep]="activeStep"
        [programData]="programData"
      ></fidi-stepper-sidebar>
    </aside>
  }

  <main
    class="main-content"
    [ngClass]="activeStep"
    [class.grey-background]="isGreyBackground"
  >
    <router-outlet></router-outlet>
    @if (isLoggedIn && isAiChatbotEnabled) {
      <fidi-chat-button (clicked)="openFidiChat()"></fidi-chat-button>
    }
  </main>
</div>
